import { LoadingSpinner } from "@/react/components/customer/modal/results/styled";
import { useAvailableLicenseForTrunks } from "../useAvailableLicenseForTrunks";

export const AvailableLicenseWrapper = ({
  children,
  contentLoading = false,
}) => {
  const { licenseExists, licenseLoading } = useAvailableLicenseForTrunks();

  const loading = licenseLoading || contentLoading;

  return (
    <>
      {loading && <LoadingSpinner size={36} />}
      {!loading && licenseExists && children}
      {!loading && !licenseExists && (
        <div>No licenses available for this customer.</div>
      )}
    </>
  );
};
